import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

//#region internal button styles
const CustomButton = ({
  sx,
  id,
  children,
  variant,
  size,
  type,
  onClick,
  fullWidth,
  disabled = false,
  className,
  icon,
  endIcon,
  href,
  arialLabel
}) => {
  const navigate = useNavigate();

  if (href) {
    onClick = () => navigate(href);
  }

  return (
    <Button
      id={id}
      variant={variant}
      size={size}
      type={type}
      onClick={onClick}
      sx={{ ...sx, height: sx && sx.height ? sx.height : "100%" }}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={icon}
      endIcon={endIcon}
      arial-label={arialLabel}
      {...(className && { className: className })}
    >
      {children}
    </Button>
  );
};

CustomButton.defaultProps = {
  id: null,
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  fullWidth: false,
  fullHeight: false,
  icon: null,
  endIcon: null,
  href: null,
};

CustomButton.propTypes = {
  id: PropTypes.string,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "utility",
    "text-link",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
  icon: PropTypes.object,
  endIcon: PropTypes.object,
  href: PropTypes.string,
};
//#endregion

export default CustomButton;

export const CustomIconButton = ({
  children,
  variant,
  size,
  type,
  onClick,
  ariaLabel,
  edge,
  ...props
}) => {
  return (
    <IconButton
      variant={variant}
      size={size}
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
      edge={edge}
      {...props}
    >
      {children}
    </IconButton>
  );
};

CustomIconButton.defaultProps = {
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  ariaLabel: null,
  edge: false,
};

CustomIconButton.propTypes = {
  edge: PropTypes.oneOf(["end", "start", false]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "utility",
    "text-link",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  "aria-label": PropTypes.string,
  disabled: PropTypes.bool
};
